/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_RefreshInputs */



/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Voice_Manager_RefreshInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_refresh = /** @type {((inputs?: Voice_Manager_RefreshInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_RefreshInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actualiser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("刷新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रीफ़्रेश करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar")
	return /** @type {LocalizedString} */ ("Refresh")
});